import { getMaintenanceMode } from '../../graphql/queries';
import {
  GET_MAINTENANCEMODE_REQUESTED,
  GET_MAINTENANCEMODE_COMPLETED,
  GET_MAINTENANCEMODE_FAILED,
} from './types';
import api from '../../services/api';
import debug from '../../services/debug';

const getMaintenanceModeAction = (auth) => async (dispatch) => {
  dispatch({
    type: GET_MAINTENANCEMODE_REQUESTED,
  });

  try {
    const { data } = await api.graphql({
      authMode: auth ? 'userPool' : 'iam',
      query: getMaintenanceMode,
    });
    debug(GET_MAINTENANCEMODE_COMPLETED, data);
    dispatch({
      type: GET_MAINTENANCEMODE_COMPLETED,
      payload: data.getMaintenanceMode,
    });
  } catch (err) {
    debug(GET_MAINTENANCEMODE_FAILED, err);

    dispatch({
      type: GET_MAINTENANCEMODE_FAILED,
      payload: err,
    });
  }
};

export default getMaintenanceModeAction;
